export default __webpack_public_path__ + "static/media/insight.0c30ccd9.svg";